import { observable, action } from "mobx";
import agent from "../agent";

class xeroStore {
    @observable xeroToken = "";
    @observable xeroListofAccountsOutgoing = [];
    @observable xeroListofAccountsIncoming = [];

    @observable xeroListofExpense = [];
    @observable xeroListofLiability = [];
    @observable outgoingAccounts = "";
    @observable incomingAccounts = "";

    @observable listXeroMappedContacts = [];
    @observable listXeroMappedEmployees = [];
    @observable xeroContacts = [];
    @observable xeroContactsFull = [];

    @observable xeroEmployees = []
    @observable xeroEmployeesFull = []


    @observable invoiceXeroId= "";
    @observable editedContactID= "";
    @observable editedxeroID= "";

    @observable xeroFirstName= ""
    @observable xeroLastName= ""
    @observable xeroEmail= ""
    @observable integrateReturnResult = [];
    @observable xeroCalendars = []

    @observable isLoading= false
    
    @observable tenantList = []

    @observable liabilityXero = ""
    @observable expenseXero = ""

    @observable payrollCalendarId = ""


    // this.xeroListofAccountsOutgoing = mappedAccounts.filter(x=>x.)
    // this.xeroListofAccountsIncoming = mappedAccounts
    
    @action
    resetXeroPopUp(){
        this.invoiceXeroId= ""
        this.xeroFirstName= ""
        this.xeroLastName= ""
        this.xeroEmail= ""
    }
    @action
    createMapInvoiceXeroContact(profileId,invoiceId){
        var data = {
            profileId: profileId,
            invoiceId: invoiceId,
            xeroCustomersId: this.invoiceXeroId
        }
        return agent.Xero.createMappedInvoiceXeroContact(data)
        .then(
            action(response => {
                return response
            })
        )
        .finally(() => {
            this.inProgress = false;
        });
    }

    @action
    updateMapInvoiceXeroContact(profileId,invoiceId){
        var data = {
            profileId: profileId,
            invoiceId: invoiceId,
            xeroCustomersId: this.invoiceXeroId
        }
        return agent.Xero.updateMapInvoiceXeroContact(data)
        .then(
            action(response => {
                return response
            })
        )
        .finally(() => {
            this.inProgress = false;
        });
    }

    @action
    deleteMapInvoiceXeroContact(profileId,invoiceId){
        var data = {
            profileId: profileId,
            invoiceId: invoiceId,
        }
        return agent.Xero.deleteMapInvoiceXeroContact(data)
        .then(
            action(response => {
                return response
            })
        )
        .finally(() => {
            this.inProgress = false;
        });
    }

    @action
    createInvoiceXeroContact(profileId,invoiceId){
        var data = {
            firstName: this.xeroFirstName,
            lastName: this.xeroLastName,
            email: this.xeroEmail,
            invoiceId :invoiceId
        }
        return agent.Xero.createInvoiceXeroContact(profileId,data)
        .then(
            action(response => {
                return response
            })
        )
        .finally(() => {
            this.inProgress = false;
        });
    }
    @action
    getInvoiceXeroContactById(profileId,invoiceId){
        return agent.Xero.getInvoiceXeroContactById(profileId,invoiceId)
        .then(
            action(response => {
                this.xeroFirstName = response.lastName
                this.xeroLastName = response.firstName
                this.xeroEmail = response.email
            })
        )
        .finally(() => {
            this.inProgress = false;
        });
    }
    @action
    getMappedInvoiceXeroContact(profileId,invoiceId){
        return agent.Xero.getMappedInvoiceXeroContact(profileId,invoiceId)
        .then(
            action(response => {
                if(response){
                    this.invoiceXeroId = response.xeroCustomersId
                    return response;
                }else{
                    return null
                }
              
            })
        )
        .finally(() => {
            this.inProgress = false;
        });
    }
    @action
    getBookingByInvoiceId(invoiceId){
        return agent.Invoice.getBookingByInvoiceId(invoiceId)
        .then(
            action(response => {
                this.xeroFirstName = response.clientFirstName
                this.xeroLastName = response.clientLastName
                this.xeroEmail = response.clientEmail
                
                return response;
            })
        )
        .finally(() => {
            this.inProgress = false;
        });
    }


    @action 
    setXeroFirstName(value){
        this.xeroFirstName = value
    }
    @action 
    setXeroLastName(value){
        this.xeroLastName = value
    }
    @action 
    setXeroEmail(value){
        this.xeroEmail = value
    }
    @action 
    setXeroDisplayId (value){
        this.xeroDisplayId = value
    }
   
    @action 
    setInvoiceXero(xeroId){
        this.invoiceXeroId = xeroId
    }

    @action
    setEditedXero(editedContactID,editedxeroID){
        this.listXeroMappedContacts.forEach(item => {
            if(item.contactId === editedContactID) {
                item.xeroId = editedxeroID
                item.isEdited = true
            }
        });
    }

    @action
    setUpdatedXero(editedContactID){
        this.listXeroMappedContacts.forEach(item => {
            if(item.contactId === editedContactID) {
                item.isUpdated = true
                var filtered = this.xeroContactsFull.filter(x=>x.value === item.xeroId)
                if(filtered.length){
                    this.xeroContacts.push(filtered[0])
                }
               
            }
        });
    }

    @action
    cancelUpdatedXero(editedContactID){
        this.listXeroMappedContacts.forEach(item => {
            if(item.contactId === editedContactID) {
                item.isUpdated = false
                this.xeroContacts = this.xeroContacts.filter(x=>x.value != item.xeroId)
                
            }
        });
    }
    @action
    cancelEditedXero(editedContactID){
        this.listXeroMappedContacts.forEach(item => {
            if(item.contactId === editedContactID) {
                item.xeroId = ""
                item.isEdited = false
            }
        });
    }


    @action
    setEditedXeroEmployee(editedContactID,editedxeroID){
        this.listXeroMappedEmployees.forEach(item => {
            if(item.contactId === editedContactID) {
                item.employeeId = editedxeroID
                item.isEdited = true
            }
        });
    }

    @action
    setUpdatedXeroEmployee(editedContactID){
        this.listXeroMappedEmployees.forEach(item => {
            if(item.contactId === editedContactID) {
                item.isUpdated = true
                var filtered = this.xeroEmployeesFull.filter(x=>x.value === item.employeeId)
                if(filtered.length){
                    this.xeroEmployees.push(filtered[0])
                }
               
            }
        });
    }

    @action
    cancelUpdatedXeroEmployee(editedContactID){
        this.listXeroMappedEmployees.forEach(item => {
            if(item.contactId === editedContactID) {
                item.isUpdated = false
                this.xeroEmployees = this.xeroEmployees.filter(x=>x.value != item.employeeId)
                
            }
        });
    }
    @action
    cancelEditedXeroEmployee(editedContactID){
        this.listXeroMappedEmployees.forEach(item => {
            if(item.contactId === editedContactID) {
                item.employeeId = ""
                item.isEdited = false
            }
        });
    }


            //     this.props.xeroStore.setOutgoingAccounts(currentProfile.outgoingInvoiceXero)
            // this.props.xeroStore.setIncomingAccounts(currentProfile.incomingInvoiceXero)
    @action
    setIncomingAccounts(value){
        this.incomingAccounts= value;
    }
    @action
    setOutgoingAccounts(value){
        this.outgoingAccounts= value;
    }

    @action
    setLiability(value){
        this.liabilityXero = value;
    }
    @action
    setExpense(value){
        this.expenseXero = value;
    }
    @action
    setPayrollCalendar(value){
        this.payrollCalendarId = value;
    }

    @action
    setXeroCode(code){
        this.xeroToken = code
    }
    @action
    connectXero(profileId, data){
        return agent.Xero.connectXero(profileId,data).then(action(
            result => {
                return result;
            }
        ));
    }



    @action
    mapExistingXeroContact(profileId, contactId, xeroId){
        var body = {
            profileId: profileId,
            contactId: contactId,
            xeroId: xeroId
        }
        return agent.Xero.mapExistingXeroContact(body).then(action(
            result => {
                return result;
            }
        ));
    }

    @action
    mapExistingXeroEmployee(profileId, contactId, employeeId){
        var body = {
            profileId: profileId,
            contactId: contactId,
            employeeId: employeeId
        }
        return agent.XeroEmployee.mapExisting(body).then(action(
            result => {
                return result;
            }
        ));
    }

    
    
    @action
    createXeroContacts(profileId, contactId){
        return agent.Xero.createXeroContacts(profileId,contactId).then(action(
            result => {
                return result;
            }
        ));
    }

     @action
    createXeroEmployee(profileId, contactId){
        return agent.XeroEmployee.create(profileId,contactId).then(action(
            result => {
                return { status: 200, data: result };
            }
        )).catch(error => {
            if (error.response) {
                return { status: error.response.status, data: error.response.data };
            }
            return { status: 500, data: error.message || "An error occurred" };
        });
    }
   

    
    @action
    deleteXeroMapping(id){
        return agent.Xero.deleteContactXero(id).then(action(
            result => {
                return result;
            }
        ));
    }

     @action
    deleteXeroMappingEmployee(id){
        return agent.XeroEmployee.delete(id).then(action(
            result => {
                return result;
            }
        ));
    }
    
    @action
    updateContactXero(id,xeroID){
        var data = {
            xeroId : xeroID
        }
        return agent.Xero.updateContactXero(id,data).then(action(
            result => {
                return result;
            }
        ));
    }
    

    @action
    updateContactEmployee(id,employeeId){
        var data = {
            employeeId : employeeId
        }
        return agent.XeroEmployee.update(id,data).then(action(
            result => {
                return result;
            }
        ));
    }

    @action
    mapAccounts(profileId){
        var data = {
            incomingInvoiceXero: this.incomingAccounts,
            outgoingInvoiceXero: this.outgoingAccounts,
        }
        return agent.Xero.mapAccounts(profileId,data).then(action(
            result => {
                return result;
            }
        ));
    }
    @action
    mapSuperSetting(profileId){
        var data = {
            liabilityXeroId: this.liabilityXero,
            expenseXeroId: this.expenseXero,
            xeroPayrollCalendarId: this.payrollCalendarId
        }
        return agent.Xero.mapSuperSetting(profileId,data).then(action(
            result => {
                return result;
            }
        ));
    }
    @action
    getXeroListOfAccounts(profileId){
        return agent.Xero.getListOfAccounts(profileId).then(action(
            result => {
                var mappedAccountsOutgoing = []
                var mappedAccountsIncoming = []
                var mappedAccountsLiability = []
                var mappedAccountsExpense = []
                result.Accounts.forEach(item => {
                    if(item.Class === "REVENUE"){
                        mappedAccountsOutgoing.push({ value: item.Code, label: item.Code + " - "+item.Name})
                    }else if(item.Class === "DIRECTCOSTS"){
                        mappedAccountsIncoming.push({ value: item.Code, label: item.Code + " - "+item.Name})
                    }else if(item.Class === "EXPENSE"){
                        mappedAccountsIncoming.push({ value: item.Code, label: item.Code + " - "+item.Name})
                        mappedAccountsExpense.push({ value: item.Code, label: item.Code + " - "+item.Name})
                    }else if(item.Class === "LIABILITY"){
                        mappedAccountsLiability.push({ value: item.Code, label: item.Code + " - "+item.Name})
                    }
                   //LIABILITY
                });
                this.xeroListofAccountsOutgoing = mappedAccountsOutgoing
                this.xeroListofAccountsIncoming = mappedAccountsIncoming
                this.xeroListofExpense = mappedAccountsExpense
                this.xeroListofLiability = mappedAccountsLiability
                return result;
            }
        ));
        
    }

    @action
    getExistingXeroCalendar(profileId){
        return agent.XeroCalendar.get(profileId).then(action(
            result => {
                var mapped = []
                result.forEach(item => {
                     mapped.push({ value: item.PayrollCalendarID, label: `${item.Name} - ${item.CalendarType}`})
                });
                this.xeroCalendars = mapped
                return result;
            }
        ));
        
    }

    @action
    getListXeroMappedContacts(profileId){
        return agent.Xero.getListXeroMappedContacts(profileId).then(action(
            result => {
                this.listXeroMappedContacts = _.orderBy(result, "contactId",'asc');
                return result;
            }
        ));
        
    }

     @action
    getListXeroMappedEmployees(profileId){
        return agent.XeroEmployee.get(profileId).then(action(
            result => {
                this.listXeroMappedEmployees = _.orderBy(result, "contactId",'asc');
                return result;
            }
        ));
        
    }

    @action
    resetResultIntegration(){
        this.integrateReturnResult = []
    }

    @action
    setCalendarId(id){
        this.payrollCalendarId = id
    }
 
    @action
    integrateIncomingInvoice(profileId, selectedIncomingInvoice){
        var body = {
            invoiceIds: selectedIncomingInvoice
        }
        return agent.Xero.integrateIncomingInvoice(profileId, body).then(action(
            result => {
                result.failed.forEach(item => {
                    this.integrateReturnResult.push({id: item.id,invoiceNumber: item.invoiceId, type: 0, code: item.code, message:`sync failed on Invoice no ${item.invoiceId}. Reason : ${item.messages}`})
                });
                result.success.forEach(item => {
                    this.integrateReturnResult.push({id: item.invoiceId,type: 1, message:`invoice number ${item.invoiceId} successfully synced`})
                });
                return this.integrateReturnResult;
            }
        )).catch(action(err => {
           console.log(err)
        }))
    }

    @action
    integrateOutgoingInvoice(profileId, selectedOutgoingInvoice){
        var body = {
            invoiceIds: selectedOutgoingInvoice
        }
        return agent.Xero.integrateOutgoingInvoice(profileId, body).then(action(
            result => {
                result.failed.forEach(item => {
                    this.integrateReturnResult.push({id: item.id,invoiceNumber: item.invoiceId, type: 0, code: item.code, message:`sync failed on Invoice no ${item.invoiceId}. Reason : ${item.messages}`})
                });
                result.success.forEach(item => {
                    this.integrateReturnResult.push({id: item.invoiceId, type: 1, message:`invoice number ${item.invoiceId} successfully synced`})
                });
                return this.integrateReturnResult;
            }
        ));
    }

    @action
    handleSelectTenant(body){
        return agent.Xero.mapXeroTenant(body).then(action(
            result => {
               
                return result;
            }
        ));
    }
    @action
    getXeroTenantId(profileId){
        return agent.Xero.getXeroTenantId(profileId).then(action(
            result => {
                
                var options = []
                result.forEach(item => {
                    options.push({ value: item.tenantId, label: item.tenantName });
                });
                this.tenantList = options
                return options;
            }
        ));
    }

    @action
    disconnect(profileId, xeroReset){
        return agent.Xero.disconnect(profileId, xeroReset).then(action(result => {
            return result
        }))
    }

     @action
    getXeroEmpoyee(profileId){
        if(!this.isLoading){
            this.isLoading = true
            return agent.XeroEmployee.getMappedXero(profileId).then(action(
                result => {
                    var xeroEmployees = []
                    var xeroEmployeesFull = []
                    result.forEach(item => {
                        var name = item.Name ? item.Name : item.FirstName + " "+ item.LastName
                        if(!item.isMapped){
                            
                            xeroEmployees.push({ value: item.EmployeeID, label: name})
                        }
                        xeroEmployeesFull.push({ value: item.EmployeeID, label: name})
                    });
                    this.xeroEmployees = xeroEmployees
                    this.xeroEmployeesFull = xeroEmployeesFull
                    this.isLoading = false
                    return result;
                }
            ));
        }
        
        
    }

    
    @action
    getXeroContacts(profileId){
        if(!this.isLoading){
            this.isLoading = true
            return agent.Xero.getXeroContacts(profileId).then(action(
                result => {
                    var xeroContacts = []
                    var xeroContactsFull = []
                    result.forEach(item => {
                        var name = item.Name ? item.Name : item.FirstName + " "+ item.LastName
                        if(!item.isMapped){
                            
                            xeroContacts.push({ value: item.ContactID, label: name})
                        }
                        xeroContactsFull.push({ value: item.ContactID, label: name})
                    });
                    this.xeroContacts = xeroContacts
                    this.xeroContactsFull = xeroContactsFull
                    this.isLoading = false
                    return result;
                }
            ));
        }
        
        
    }

    

}

export default new xeroStore();
